<query-filters *ngIf="!!filters"
               (filtersChanged)="filters = $event"
               [filters]="filters"></query-filters>
